import { Suspense, useEffect } from 'react';
import { Provider } from 'react-redux';
import store from './_services/Redux/store';
import { Loader } from '@consolidocs-ui/components';
import { Authenticate, appThemeOptions } from '@consolidocs-ui/components';
import AppContent from './Components/AppContent';
import { CssVarsProvider, extendTheme } from '@mui/joy/styles';
import { bindGlobalUppyListeners } from './lib/uppyInstance';
import { default as useGlobalErrorHandler } from '@consolidocs-ui/hooks/useGlobalErrorHandler';
import { signInOptions } from '_utils/authConfig';
import './App.css';

const joyTheme = extendTheme({
  ...appThemeOptions,
  fontFamily: {
    body: `'Roboto', sans-serif`,
    display: `'Roboto', sans-serif`,
    code: 'monospace',
  },
  // Only 300/400/500/700 Roboto faces are loaded; Joy's default lg is 600.
  fontWeight: { sm: 300, md: 500, lg: 700, xl: 700 },
  // The app header sits at 10001, so full-screen dialogs step over it at
  // 10002 and the charts dialog at 10003. Menus, selects and tooltips are
  // portalled to the body, so at Joy's defaults (1000/1500) they would open
  // behind any of those. Raised here once rather than on each popup.
  zIndex: { popup: 10004, tooltip: 10005 },
});

function App() {
  // Initialize global error handling
  useGlobalErrorHandler();

  useEffect(() => {
    bindGlobalUppyListeners();
  }, []);

  // The theme wraps Authenticate too, so the sign-in screen gets the app's
  // font and follows its light/dark mode.
  return (
    <CssVarsProvider theme={joyTheme}>
      <Authenticate signIn={signInOptions}>
        <Suspense fallback={<Loader fullscreen size="lg" />}>
          <Provider store={store}>
            <AppContent />
          </Provider>
        </Suspense>
      </Authenticate>
    </CssVarsProvider>
  );
}

export default App;
